__turbopack_context__.v({
  "bar": "Tabs-module__OSnIQq__bar",
  "container": "Tabs-module__OSnIQq__container",
  "floater": "Tabs-module__OSnIQq__floater",
  "icon": "Tabs-module__OSnIQq__icon",
  "tab": "Tabs-module__OSnIQq__tab",
});
